import axios from "axios";

let currentVersion = null;
let toastShown = false;
let lastCheck = 0;
const CHECK_INTERVAL = 60 * 1000; // Minimum 1 minute between checks on route changes

export default async function checkVersion(toast) {
  const now = Date.now();
  if (now - lastCheck < CHECK_INTERVAL && currentVersion) {
    return;
  }
  lastCheck = now;

  try {
    // Adding a cache-busting timestamp to the request
    const { data } = await axios.get(`/version.json?t=${now}`);

    if (!currentVersion) {
      currentVersion = data.version;
      return;
    }

    if (data.version !== currentVersion && !toastShown) {
      toastShown = true;
      toast.info(
        "A new version is available! Please refresh to ensure everything works correctly.",
        {
          timeout: 0, // Don't auto-dismiss
          closeOnClick: false,
          pauseOnHover: true,
          draggable: false,
          onClose: () => {
            window.location.reload();
          },
          // Using a button for clear action
          onClick: () => {
            window.location.reload();
          },
        },
      );
    }
  } catch (error) {
    // Silently fail to not disturb the user if the check itself fails
    // eslint-disable-next-line no-console
    console.debug("Failed to check version:", error);
  }
}
